import React, { useEffect } from "react";
import Marquee from "react-fast-marquee";

import "./Footer.scss";

// Assets
import { ReactComponent as FooterTop } from "../../assets/media/icons/FooterContainer.svg";
import FooterCoin from "../../assets/media/icons/FooterCoin.gif";
import DiscordPixelLogo from "../../assets/media/icons/DiscordPixel.png";
import TwitterPixelLogo from "../../assets/media/icons/TwitterPixel.png";

const Footer = () => {
  // TODO: Need to place Discord link to CTA button
  // TODO: Need to discuss CTA button's background color

  return (
    <footer className="footer">
      <div className="footer-top-wrapper">
        <div className="gold-effect" />
        <img src={FooterCoin} alt="" />
        <FooterTop className="footer-top" />
      </div>
      <Marquee className="footer-marquee" gradient={false}>
        <span>BEAR WITH US</span>
        <span>BEAR WITH US</span>
        <span>BEAR WITH US</span>
        <span>BEAR WITH US</span>
        <span>BEAR WITH US</span>
      </Marquee>
      <div className="footer-bottom">
        <div className="footer-bottom-left">
          <div className="footer-barberians">© Fortune Foes GAME 2025</div>
          {/* <div className="footer-terms">TERMS</div>
          <div className="footer-faq">FAQ</div> */}
        </div>
        <div className="footer-bottom-right">
          <a
            href="https://x.com/FortuneFoes"
            target="_blank"
            rel="noreferrer"
          >
            <div className="twitter-button">
              <img width={50} src={TwitterPixelLogo} alt="" />
            </div>
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
